import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import SetUpPassword from '@/features/auth/components/templates/password/set-up-password';

const resetPasswordSearchSchema = z.object({
  token: fallback(z.string().uuid(), '').default(''),
});

export const Route = createFileRoute('/(auth)/set-up-password')({
  component: SetUpPassword,
  validateSearch: zodValidator(resetPasswordSearchSchema),
});
